import { StepVerticalSettings } from './types';

export const stepVerticalSettings: StepVerticalSettings = {
  componentVariants: {
    color: {
      prop: 'color',
      variants: {
        disabled: {
          backgroundColor: 'gray.extraLight',
        },
        active: {
          backgroundColor: 'success.main',
        },
        completed: {
          backgroundColor: 'success.light',
        },
      },
    },
    size: {
      prop: 'size',
      variants: {
        regular: {
          paddingTop: 4,
          paddingBottom: 4,
          paddingLeft: 5,
          '&:before': {
            content: "''",
            position: 'absolute',
            top: 0,
            left: 0,
            width: '4px',
            height: '100%',
            borderRadius: 10,
          },
        },
      },
    },
    text: {
      prop: 'text',
      variants: {
        disabled: {
          color: 'gray.main',
        },
        active: {
          color: 'success.main',
        },
        completed: {
          color: 'success.light',
        },
      },
    },
  },
};
